import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RunCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 3v18M21 3v18M18 7.158 15.5 4m0 0L13 7.158M15.5 4v15M11 16.8 8.5 20m0 0L6 16.8M8.5 20V5" }) }) });
}
const RunCustom = forwardRef(_RunCustom);
export { RunCustom };
